
/**
 * 手动搜索结果展示组件 (Vue2版本)
 * 根据关键词搜索结果展示可选的筛选项，支持高亮显示和选择操作
 */
import { FieldType } from './enum'
import { handleCascadeSelect } from './useCascade'
import { getName } from './useFast'
import { toggleOption } from './useToggle'


export default {
  name: 'Manual',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    searchLoading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    filterOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showEmpty: false,
      FieldType
    }
  },
  watch: {
    searchLoading(newVal) {
      if (newVal === false && this.data.length === 0) {
        setTimeout(() => {
          this.showEmpty = true
        }, 200)
      } else {
        this.showEmpty = false
      }
    }
  },
  methods: {
        /**
         * 处理选项点击事件
         * @param opt 被点击的选项
         * @param item 所属的分类项
         */
        handleItemClick(opt, item) {
            // 检查是否是级联选择类型
            if (item.fieldType === FieldType.SINGLE_CASCADE) {
                // 使用级联选择逻辑
                handleCascadeSelect(opt, item, this.filterOptions)
            }
            else {
                // 使用普通的切换逻辑
                toggleOption(opt, item, this.filterOptions)
            }
        },

        /**
         * 获取选项的来源路径（用于区分同名选项）
         * @param opt 选项对象
         * @param item 所属分类
         * @returns 来源路径字符串
         */
        getOptSource(opt, item) {
            if (item.fieldType !== FieldType.SINGLE_CASCADE) {
                return ''
            }
            // 如果有重名选项，显示来源路径
            if ((item.manualOptions?.filter(x => getName(x) === getName(opt))?.length || 0) >= 2) {
                return Object.values(opt.cascadeObj).map(x => x.name).join('/')
            }
            return ''
        },

        /**
         * 获取带高亮的选项名称
         * @param opt 选项对象
         * @returns 带HTML高亮标签的名称
         */
        getOptName(opt) {
            const name = getName(opt)
            // 用红色高亮关键词
            return name.replace(this.keyword, `<span style="color: #EE5757;">${this.keyword}</span>`)
        },

        /**
         * 触发反馈事件
         */
        handleFeedback() {
            this.$emit('feedback')
        },

        /**
         * 处理分组标题点击事件
         * @param item 被点击的分组项
         */
        handleGroupTitleClick(item) {
            if (item.fieldType !== FieldType.SECTION) {
                return
            }
            // 发送清空关键词并导航到分组的事件
            this.$emit('clearKeywordAndNavigate', item.id)
        },

        getUniqueOptions(item) {
            if ([FieldType.CHECKBOX, FieldType.SINGLE].includes(item.fieldType)) {
                const seen = new Set()
                return item.manualOptions?.filter((option) => {
                    if (seen.has(option.id)) {
                        return false
                    }
                    seen.add(option.id)
                    return true
                }) || []
            }
            return item.manualOptions || []
        }
  }
}
